export default __webpack_public_path__ + "static/media/referral.67f33b7e.svg";